import React , {memo, useEffect , useState} from 'react';
import { useSelector } from 'react-redux';
import classes from './Header.module.scss'
import NotificationIcon from './../Notification/NotificationIcon';
import NotificationDrawer from '../Notification/NotificationDrawer';
import Hamburger from './../Hamburger/Hamburger';

const Header = () => {
    const [isNotification , setisNotification] = useState(false);
    const state = useSelector(state=>state.interactions.notification)
    const data = JSON.parse(localStorage.getItem('data'));

    useEffect(()=>{
        if(data !==null){
            if(data.usertype === "M"){
                setisNotification(true)
            }
        }
    },[])

    if(!data){
        return null;
    }

    let Name = data.empname;
    let newName
    if(Name.length>15){
        newName = Name.substring(0, 17) + "..."
        
    }else{
        newName = Name
    }  
  
    return (            
            <div className={classes.Header}>
                <div className={classes.HeaderDetails}>
                    <div className={classes.Name}>
                        <p>{newName}</p>
                    </div>
                    <div className={classes.Designation}>
                        <div>
                            <p><b>Employee ID:</b> {data.empid}</p>
                        </div>
                    </div>
                </div>
                <div className={classes.HeaderButtons}>
                {isNotification && <NotificationIcon/>}
                    <Hamburger />
                </div>
            </div>        
    )
}
export default memo(Header)